/** @format */

"use client";

import { PromotionAPI } from "@/api/promotion/promotion.api";
import { DiscountComponent } from "@/components/ui/Discount/discount";
import { FlashSaleCountDown } from "@/components/ui/Flashsale/flashsale-countdown";
import { ImageLoader } from "@/components/ui/image-loader";
import { ProductCard } from "@/components/ui/product/product-card";
import { SectionHeader } from "@/components/ui/section/section-header";
import {
  discountTypeEnum,
  ProductPromotion,
  PromotionInterface,
  PromotionTypeEnum,
} from "@/types/promotion";
import { FormatUtils } from "@/utils/format";
import { useEffect, useState } from "react";
import { Clock, GiftIcon, Zap } from "lucide-react";

export const FlashSaleComponentView = () => {
  const [flashSale, setFlashSale] = useState<PromotionInterface>();
  const [promotionProducts, setPromotionProducts] = useState<
    ProductPromotion[]
  >([]);
  const [loading, setLoading] = useState(true);

  // Fetch flash sale
  const fetchFlashSale = async () => {
    try {
      setLoading(true);
      const res = await PromotionAPI.getAllPromotionsFromStore({
        limit: 1,
        promotionType: PromotionTypeEnum.FLASHSALE,
      });
      if (res.status === 200 && res.data.length > 0) {
        const promotion = res.data[0] as PromotionInterface;
        setFlashSale(promotion);
        setPromotionProducts(promotion.promotionProducts);
      }
    } catch (error) {
      console.error("Error fetching flash sale:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFlashSale();
  }, []);

  if (loading) {
    return (
      <section className="py-16 bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50">
        <div className="container mx-auto px-6">
          <div className="animate-pulse">
            <div className="h-20 bg-gray-200 rounded-lg mb-8 mx-auto max-w-2xl"></div>
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="h-80 bg-gray-200 rounded-lg"></div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!flashSale || !flashSale.isActive) return null;

  return (
    <section className="py-16 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-20 h-20 bg-red-500 rounded-full animate-pulse"></div>
        <div className="absolute top-32 right-20 w-16 h-16 bg-orange-500 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute bottom-20 left-1/4 w-12 h-12 bg-yellow-500 rounded-full animate-pulse delay-500"></div>
        <div className="absolute bottom-32 right-1/3 w-14 h-14 bg-red-400 rounded-full animate-pulse delay-700"></div>
      </div>

      <div className="container mx-auto  relative z-10">
        {/* Centered Header Section */}
        <div className="text-center mb-12">
          {/* Main Title - Centered */}
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-2 h-6 bg-accent rounded-full"></div>
            <h2 className="title-gradient block text-lg sm:text-xl lg:text-2xl font-bold uppercase ">
              Flash Sale HÔM NAY
            </h2>

            <div className="flex items-center gap-2 bg-gradient-to-r from-red-600 to-orange-500 rounded-full px-4 py-1 shadow-lg">
              <Clock className="w-5 h-5 text-white animate-spin" />
              <FlashSaleCountDown
                promotion={flashSale}
                className="text-white font-mono font-bold tracking-wider text-lg"
              />
            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-4 mb-6">
            {/* <div className="flex items-center justify-center gap-3">
              <GiftIcon className="w-8 h-8 text-red-500 animate-bounce" />
              <h2 className="text-4xl py-4 md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-600 via-orange-500 to-yellow-500 animate-pulse">
                SẢN PHẨM SALE TRONG NGÀY
              </h2>
              <GiftIcon className="w-8 h-8 text-red-500 animate-bounce" />
            </div> */}

            {/* Flash Sale Logo and Countdown */}
            {/* <div className="flex items-center justify-center gap-4 flex-wrap">
              <div className="relative h-[35px] w-[140px] sm:w-[180px]">
                <ImageLoader
                  src={"/images/flashsale/flashsale.png"}
                  alt={"flash-sale"}
                  fill
                  quality={100}
                  priority
                  className="object-contain drop-shadow-lg"
                />
              </div>
              <div className="flex items-center gap-2 bg-gradient-to-r from-red-600 to-orange-500 rounded-full px-4 py-2 shadow-lg">
                <Clock className="w-5 h-5 text-white animate-spin" />
                <FlashSaleCountDown
                  promotion={flashSale}
                  className="text-white font-mono font-bold tracking-wider text-lg"
                />
              </div>
            </div> */}
          </div>

          {/* Description */}
          {/* <div className="max-w-3xl mx-auto ">
            <p className="capitalize text-gray-600  text-lg leading-relaxed bg-white/70 backdrop-blur-sm rounded-xl p-6 shadow-md border border-white/30">
              các sản phẩm đang được sale
            </p>
          </div> */}

          {/* Stats or additional info */}
          {/* <div className="flex items-center justify-center gap-4 mt-8 px-2 ">
            <div className="flex flex-col items-center gap-2 bg-white/80 backdrop-blur-sm rounded-md px-4 py-2 shadow-md">
              <Zap className="w-5 h-5 text-yellow-500" />
              <span className="font-semibold text-gray-700">
                Giảm giá đặc biệt
              </span>
            </div>
            <div className="flex flex-col items-center gap-2 bg-white/80 backdrop-blur-sm rounded-md px-4 py-2 shadow-md">
              <GiftIcon className="w-5 h-5 text-red-500" />
              <span className="font-semibold text-gray-700">
                Số lượng có hạn
              </span>
            </div>
            <div className="flex flex-col items-center gap-2 bg-white/80 backdrop-blur-sm rounded-md px-4 py-2 shadow-md">
              <Clock className="w-5 h-5 text-blue-500" />
              <span className="font-semibold text-gray-700">
                Thời gian có hạn
              </span>
            </div>
          </div> */}
        </div>

        {/* Products Grid */}
        <div className="relative">
          {/* Decorative border */}
          <div className="absolute inset-0 bg-gradient-to-r  rounded-2xl blur-sm -z-10 transform scale-105"></div>

          <div className=" backdrop-blur-sm rounded-2xl border border-white/50">
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 md:gap-6">
              {promotionProducts.map((productPromotion, index) => (
                <div
                  key={productPromotion.productId}
                  className="transform hover:scale-105 transition-all duration-300 hover:shadow-lg"
                  style={{
                    animationDelay: `${index * 100}ms`,
                  }}>
                  <ProductCard
                    product={productPromotion.product}
                    promotion={flashSale}
                  />
                </div>
              ))}
            </div>

            {/* Show more button if needed */}
            {promotionProducts.length > 8 && (
              <div className="text-center mt-8">
                <button className="bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white font-semibold py-3 px-8 rounded-full shadow-lg transform hover:scale-105 transition-all duration-300">
                  Xem thêm sản phẩm
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Additional CSS for animations */}
      <style jsx>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};
